'use client'

import { useAppDispatch, useAppSelector } from '@/lib/hooks'
import { setLocationMetadata as setLocationMetadataAction } from '@/lib/redux'

export const useLocationMetadata = () => {
  const dispatch = useAppDispatch()
  const {
    order_sources,
    delivery_methods,
    future_order_types,
    business_settings,
  } = useAppSelector((state) => state.appSession)

  const setLocationMetadata = (metadata: any) => {
    dispatch(setLocationMetadataAction(metadata))
  }

  return {
    order_sources,
    delivery_methods,
    future_order_types,
    business_settings,
    setLocationMetadata,
  }
}
